import util from "@/util";
import taskChecklistItemModelDefinition from '../taskChecklistItem'

export default {
  create({ userId }, data, BACKEND) {
    let checklistItem1Id = util.get_new_uuid(); // TODO replace
    let checklistItem2Id = util.get_new_uuid(); // TODO replace
    const empty_checklist_item = taskChecklistItemModelDefinition.schema.create;

    return {
      checklist: {
        [checklistItem1Id]: empty_checklist_item({}, { done: false, name: 'Planning', sortidx: 100, duration: 5 }),
        [checklistItem2Id]: empty_checklist_item({}, { done: false, name: 'Item 2', sortidx: 200, duration: 10 })
      },
      // TODO ... move task meta content here ...
    }
  },

  fields: {
    checklist: {},
    /* checklist: { validate_bolt_type: 'TaskChecklistItem[]' }, --> See rules.bolt */
  }
};
